import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { config, PRODUCT_SLUG } from "../config";

export const DEFAULT_BRAND_INFO = {
  app_logo_url: "/idom-logo.webp",
  fav_icon_url: "/favicon.jpg",
  app_name: "iDoM",
  product_name: "HRMS",
  product_version: "v1.0.0",
  product_description:
    "Comprehensive human resource management system with employee records, attendance tracking, leave management, and performance evaluations.",
};

const fetchBrandInfo = async () => {
  const baseUrl = config.apiurl
    ? config.apiurl.replace(/\/+$/, "")
    : "https://api.idom.in";
  const slug = PRODUCT_SLUG || "hrms";

  const response = await axios.get(`${baseUrl}/get-app-and-product-version`, {
    params: { product_slug: slug },
  });

  return response.data;
};

export const useAppBrandInfo = () => {
  const query = useQuery({
    queryKey: ["app-brand-info", PRODUCT_SLUG || "hrms"],
    queryFn: fetchBrandInfo,
    staleTime: 60 * 60 * 1000, // 1 hour
    cacheTime: 24 * 60 * 60 * 1000, // 24 hours
    refetchOnWindowFocus: false,
    placeholderData: DEFAULT_BRAND_INFO,
    onError: (err) => {
      console.warn("Failed to fetch app brand info, using fallback:", err);
    },
  });

  return {
    ...query,
    data: query.data || DEFAULT_BRAND_INFO,
  };
};

export default useAppBrandInfo;
